<dsh-multi-input-field
    *transloco="let t; scope: 'invoices-field'; read: 'invoicesField'"
    [formControl]="control"
    [label]="t('label')"
></dsh-multi-input-field>
